import { ThemeProvider } from 'styled-components';
import { AuthProvider } from '../contexts/AuthContext';
import { theme } from '../styles/theme';

const AppProvider = ({ children }) => {
    return (
        <ThemeProvider theme={theme}>
            <AuthProvider>
                {children}
            </AuthProvider>
        </ThemeProvider>
    );
};

export default AppProvider;